export enum FONT_VARIANT {
    DEFAULT = '',
    BOLD = 'bold',
    UPPERCASE = 'uppercase',
    DASHED = 'dashed',
    LINE_TROUGH = 'line-through',
    UNDER_LINE = 'underline',
}

export enum FONT_COLOR {
    PRIMARY1 = "color-primary-1",
    PRIMARY1_10 = "color-primary-1-10",
    PRIMARY2 = 'color-primary2',
    PRIMARY3 = 'color-primary3',
    PRIMARY3_50 = 'color-primary3-50',
    // DEPRECATED: this variable doesn't exist in CSS any more
    // TODO: go over the project and replace with NEUTRAL_1_WHITE instead
    NEUTRAL_WHITE = 'color-neutral-white',
    NEUTRAL_1_WHITE = 'color-neutral-1-white',
    ACCENT1 = 'color-accent1',
    ACCENT2 = 'color-accent2',
    ACCENT3 = 'color-accent3',
    ACCENT4 = 'color-accent4',
    NEUTRAL3 = 'color-neutral3',
    NEUTRAL10 = 'color-neutral10',
    NEUTRAL11_MENU = 'color-neutral11-menu',
    NEUTRAL12 = 'color-neutral12',
    SEMANTIC_DANGER = 'color-semantic-danger',
    SEMANTIC_WARNING = 'color-semantic-warning',
    SEMANTIC_SUCCESS = 'color-semantic-success',
    SEMANTIC_1 = 'color-semantic-1',
    SEMANTIC_3 = 'color-semantic-3',
}

export interface FontProps {
    children: React.ReactNode;
    variant?: FONT_VARIANT | FONT_VARIANT[];
    color?: FONT_COLOR;
}


export function fontClasses({ variant, color }: FontProps) {
    const classes: any[] = Array.isArray(variant) ? [...variant] : [variant];
    classes.push(color);
    return classes.filter(c => c).join(' ');
}
